<ng-container *ngIf="offer">
  <div class="ots-compact" data-testid="offer-totals-compact" *ngIf="compact; else full">
    <span data-testid="offer-volume">{{ offer.volumeM3 != null ? ((offer.volumeM3 | number: '1.0-2') + ' m³') : '—' }}</span>
    <span class="ots-sep">·</span>
    <span data-testid="offer-wood-per-m3">{{ offer.salePrice != null ? (offer.salePrice | currency: currencyCode : 'symbol' : '1.2-2') : '—' }}</span>
    <span class="ots-sep">·</span>
    <span data-testid="offer-wood-total">{{ offer.woodTotal != null ? (offer.woodTotal | currency: currencyCode : 'symbol' : '1.2-2') : '—' }}</span>
  </div>

  <ng-template #full>
    <div class="flex flex-col bg-card shadow rounded overflow-hidden" data-testid="offer-totals">
      <div class="p-8 bg-gray-50 dark:bg-gray-700">
        <p class="text-lg font-medium">{{ 'offers.detail.totals.title' | transloco }}</p>
        <p class="text-secondary">{{ 'offers.detail.totals.subtitle' | transloco }}</p>
      </div>
      <div class="p-8 grid grid-cols-3 gap-4">
        <div class="flex flex-col">
          <span class="text-secondary text-sm">{{ 'offers.detail.totals.volume' | transloco }}</span>
          <strong class="text-xl" data-testid="offer-volume">{{ offer.volumeM3 != null ? ((offer.volumeM3 | number: '1.0-2') + ' m³') : '—' }}</strong>
        </div>
        <div class="flex flex-col">
          <span class="text-secondary text-sm">{{ 'offers.detail.totals.woodPerM3' | transloco }}</span>
          <strong class="text-xl" data-testid="offer-wood-per-m3">{{ offer.salePrice != null ? (offer.salePrice | currency: currencyCode : 'symbol' : '1.2-2') : '—' }}</strong>
        </div>
        <div class="flex flex-col">
          <span class="text-secondary text-sm">{{ 'offers.detail.totals.woodTotal' | transloco }}</span>
          <strong class="text-xl" data-testid="offer-wood-total">{{ offer.woodTotal != null ? (offer.woodTotal | currency: currencyCode : 'symbol' : '1.2-2') : '—' }}</strong>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
